export class Icon {
    public static NAV_HOME = "fass fa-house";
    public static NAV_BACK = "fass fa-arrow-left";

    public static ARROW_LEFT = "far fa-arrow-left";
    public static ARROW_RIGHT = "far fa-arrow-right";

    public static CHEVRON_LEFT = "fasr fa-chevron-left";
    public static CHEVRON_RIGHT = "fasr fa-chevron-right";

    public static MEDIA_TYPE_GALLERY = "fass fa-images";
    public static MEDIA_TYPE_IMAGE = "fass fa-image";
    public static MEDIA_TYPE_VIDEO = "fass fa-video";
    public static MEDIA_TYPE_IFRAME = "fass fa-cube";

    public static VIDEO_STATE_PAUSED = "fass fa-play";
    public static VIDEO_STATE_PLAYING = "fass fa-pause";

    public static PRELOADER_WARNING = "fal fa-exclamation-triangle";
}